import React from 'react';

import Heading from '@atlaskit/heading';

import SuccessContainer from './SuccessContainer';

export default () => (
	<SuccessContainer>
		<Heading size="xsmall">Thanks for your feedback</Heading>
	</SuccessContainer>
);
